import { presentedValue, truthSequence } from './exercises/truefalse';
import { shuffle } from './rng';
import type { Rng } from './rng';
import type { Task } from './session';

export interface BuildRepeatParams {
  tasks: readonly Task[];
  erroredTaskIds: readonly string[];
  rng: Rng;
  makeId: () => string;
}

/** Сессия строится из ЗАДАНИЙ, в которых были ошибки, а не из фактов.
 *  Тип не переназначается: восстановить выражение «верно/неверно» под тип
 *  «четыре варианта» невозможно, а ошибка в одном сравнении дала бы два
 *  задания вместо одного (раздел 5.9). */
export function buildRepeatSession(params: BuildRepeatParams): Task[] {
  const { tasks, erroredTaskIds, rng, makeId } = params;

  const byId = new Map(tasks.map((task) => [task.id, task]));
  const missing = erroredTaskIds.filter((id) => !byId.has(id));
  if (missing.length > 0) {
    throw new Error(
      `buildRepeatSession: этих заданий нет в исходной сессии: ${missing.join(', ')}`,
    );
  }

  const errored = new Set(erroredTaskIds);
  const source = tasks.filter((task) => errored.has(task.id));
  if (source.length === 0) {
    throw new Error('buildRepeatSession: список ошибочных заданий пуст');
  }

  const truths = truthSequence(source.filter((t) => t.type === 'truefalse').length, rng);
  let truthCursor = 0;

  return source.map((task, index) => {
    const base: Task = { ...task, id: makeId(), index };
    if (task.type === 'choice4') {
      // Значения те же, меняется только порядок кнопок (раздел 5.9 спеки).
      // Пересобирать варианты нельзя: задание обязано проверять тот же пример.
      return { ...base, options: shuffle(task.options ?? [], rng) };
    }
    if (task.type === 'truefalse') {
      return { ...base, presented: presentedValue(task.fact, truths[truthCursor++], rng) };
    }
    return base;
  });
}
